import { Button, Checkbox, MenuProps, Tooltip } from "antd/lib";
import type { Category } from "api/config/chalice-types";
import { ReviewStatus } from "api/config/chalice-types";
import { MdOutlineVisibility, MdOutlineVisibilityOff } from "react-icons/md";
import { Post } from "store/posts/postConstants";
import { PostCategoryTag } from "../../components/PostCategoryTag";
import PostReviewActions from "../../components/PostReviewActions";
import PostCardMenu from "../PostCardMenu";

interface PostCardHeaderProps {
  post: Post;
  disabled: boolean;
  changeReviewStatus: (reviewStatus: ReviewStatus | null) => Promise<unknown>;
  isMenuLoading: boolean;
  isMenuOpen: boolean;
  menuItems: MenuProps["items"];
  handleMenuClick: MenuProps["onClick"];
  handleMenuOpenChange: (open: boolean) => void;
  toggleShowInputs: () => void;
  canShowInputs: boolean;
  isShowingInputs: boolean;
  onUpdateCategory: (categoryId: string | null) => Promise<unknown>;
  isUpdatingCategory: boolean;
  inSelectionMode: boolean;
  isSelected: boolean;
  selectPost: () => void;
  categories: Category[];
  isLoadingCategories?: boolean;
}

const PostCardHeader = ({
  post,
  disabled,
  changeReviewStatus,
  isMenuLoading,
  isMenuOpen,
  menuItems,
  handleMenuClick,
  handleMenuOpenChange,
  toggleShowInputs,
  canShowInputs,
  isShowingInputs,
  onUpdateCategory,
  isUpdatingCategory,
  inSelectionMode,
  isSelected,
  selectPost,
  categories,
  isLoadingCategories,
}: PostCardHeaderProps) => {
  // Currently only includes Review Actions. Can be expanded later.
  return (
    <div className="flex justify-between items-center gap-2 w-full pr-1 pl-3 py-1">
      <div className="flex items-center gap-2">
        {inSelectionMode && (
          <Checkbox
            checked={isSelected}
            onChange={selectPost}
            onClick={(e) => e.stopPropagation()}
            className="cursor-pointer"
          />
        )}
        <PostCategoryTag
          post={post}
          categories={categories}
          isLoadingCategories={isLoadingCategories}
          isUpdatingCategory={isUpdatingCategory}
          disabled={disabled}
          onUpdateCategory={onUpdateCategory}
        />
      </div>

      {/* Right-aligned controls */}
      <div className="flex items-center gap-1">
        <PostReviewActions
          post={post}
          disabled={disabled}
          changeReviewStatus={changeReviewStatus}
        />
        {canShowInputs && (
          <Tooltip title={isShowingInputs ? "Hide inputs" : "Show inputs"}>
            <Button
              className="!size-10 !text-antd-colorText"
              type="text"
              icon={
                isShowingInputs ? (
                  <MdOutlineVisibilityOff size={18} />
                ) : (
                  <MdOutlineVisibility size={18} />
                )
              }
              onClick={(e) => {
                e.stopPropagation(); // Prevent other card actions
                toggleShowInputs();
              }}
              disabled={disabled}
            />
          </Tooltip>
        )}
        <PostCardMenu
          isMenuLoading={isMenuLoading}
          isMenuOpen={isMenuOpen}
          menuItems={menuItems}
          handleMenuClick={handleMenuClick}
          handleMenuOpenChange={handleMenuOpenChange}
        />
      </div>
    </div>
  );
};

export default PostCardHeader;
